import * as R from 'ramda'

import type { TimeSlotFieldProps } from '@ngb-frontend/shared/types'

export const isTimeSlotFieldProps = (x: unknown): x is TimeSlotFieldProps =>
  R.allPass([R.pipe(R.prop('options'), Array.isArray)])(x)
